import React from 'react';
import UserDetailsView from 'spa/containers/PartnerDashboard/UserDetails';

const UserDetails = () => <UserDetailsView />;

export default UserDetails;
